<template>
  <div class="container">
    <div class="outer_title">
      <h2 class="space_y_50_down">{{ title }}</h2>
      <br />
      <div class="grid">
        <div>
          <h3>
            Earn <br />
            Money
          </h3>
          <p>
            Teach online from your home and earn money. For all paid programs,
            Upskill shares 30%-50% revenue with its trainers.
          </p>
        </div>
        <div>
          <h3>
            Maximum <br />
            Convenience
          </h3>
          <p>
            Upskill will take care of all the hassles of marketing, sales
            conversion, and logistics for you, so that you can focus exclusively
            on spreading knowledge.
          </p>
        </div>
        <div>
          <h3>
            Enjoy <br />
            Flexibility
          </h3>
          <p>Teach online on your schedule at your convenience.</p>
        </div>
        <div>
          <h3>
            Be <br />
            Creative
          </h3>
          <p>
            You get to design your curriculum and decide the way you want to
            teach.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    content: {
      type: Array,
      required: true,
      heading: String,
      subtitle: String,
    },
  },
}
</script>

<style scoped>
.outer_title h2 {
  margin-bottom: 35px;
  font: 700 3rem/3.75rem 'Open Sans';
  letter-spacing: -2.4px;
  color: #000000;
  text-align: center;
}
.grid {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(289px, 1fr));
  grid-gap: 48px;
  place-items: unset;
}
.grid > div {
  background-image: linear-gradient(#0062ff, #002c72);

  border-radius: 10px;
  max-width: 320px;
  min-height: 329px;
}
.grid > div h3 {
  padding-left: 29px;
  padding-top: 20px;
  padding-bottom: 20px;
  font: 700 1.5rem/1.875rem 'Open Sans';
  letter-spacing: -1.2px;
  color: #ffffff;
  word-wrap: break-word;
  border-bottom: 1px solid white;
}
.grid > div p {
  padding-left: 29px;
  padding-top: 20px;
  font: 400 1.125rem/1.75rem 'Open Sans';
  letter-spacing: 0px;
  color: #ffffff;
  word-wrap: break-word;
  max-width: 250px;
}
@media screen and (max-width: 680px) {
  .grid {
    grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));
    grid-gap: 48px;
    place-items: center;
  }
  .grid > div {
    background-image: linear-gradient(#0062ff, #002c72);

    border-radius: 10px;
    min-width: 90%;

    min-height: 329px;
  }
}
</style>
